import Markdown from "react-markdown";
import styles from "./Announcement.module.scss";
import {
  ProductAnnouncement,
  useProductAnnouncement,
} from "./useProductAnnouncement";

interface AnnouncementProps {
  id: string;
  initialAnnouncement: ProductAnnouncement;
}

export default function Announcement({
  id,
  initialAnnouncement,
}: AnnouncementProps) {
  const announcement = useProductAnnouncement(id, initialAnnouncement);

  if (!announcement) {
    return <></>;
  }
  const { active, content } = announcement;
  return (
    <>
      {active && (
        <section className={styles.Announcement}>
          <div className="AppLayout">
            <Markdown components={{ a: LinkRenderer }}>{content}</Markdown>
          </div>
        </section>
      )}
    </>
  );
}

function LinkRenderer(props) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  );
}
